import React, { forwardRef } from "react";
import styled from "styled-components";
import HoverVideo from "./HoverVideo";
import { VideoMeta } from "../../../services/video.service";

type Props = {
  video: VideoMeta;
  isHover: boolean;
  onHoverStart: () => void;
  onHoverEnd: () => void;
  onClick: () => void;
};

const VideoCard = forwardRef<HTMLDivElement, Props>(
  ({ video, isHover, onHoverStart, onHoverEnd, onClick }, ref) => {
    return (
      <GridItem
        ref={ref}
        onMouseEnter={onHoverStart}
        onMouseLeave={onHoverEnd}
        onClick={onClick}
      >
        <ThumbContainer>
          <ThumbImg src={video.thumbnailUrl} alt="video thumbnail" />
          <HoverVideo hlsUrl={video.hlsUrl} isHover={isHover} />
        </ThumbContainer>
      </GridItem>
    );
  }
);

VideoCard.displayName = "VideoCard";

export default VideoCard;

const ThumbContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: black;
  overflow: hidden;
`;

const GridItem = styled.div`
  background: #000;
  overflow: hidden;
  aspect-ratio: 9 / 16;
  width: 100%;
  height: auto;
  position: relative;
  cursor: pointer;
`;

const ThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;